import { Draft } from '@ublend-npm/th90-editor';

export const unfinishedUploadBlock = ({
  data: { type, readyForAction, url },
}) => type === 'file' && (!readyForAction || !url);

export const atLeastOneUnfinishedBlock = (blocks) =>
  blocks.findIndex(unfinishedUploadBlock) !== -1;

export const withoutUnfinishedBlocks = (blocks) =>
  blocks.filter((b) => !unfinishedUploadBlock(b));

export const removeUnfinishedFileBlocksFromContent = ({
  blocks,
  entityMap,
}) => ({ entityMap, blocks: withoutUnfinishedBlocks(blocks) });

export const createStateWithMention = ({ user }) => {
  const mentionedUser = `@${user.firstName} ${user.lastName}`;
  return {
    blocks: [
      {
        key: Draft.genKey(),
        text: `${mentionedUser} `,
        type: 'unstyled',
        depth: 0,
        inlineStyleRanges: [],
        entityRanges: [
          {
            offset: 0,
            length: mentionedUser.length,
            key: 0,
          },
        ],
        data: {},
      },
    ],
    entityMap: {
      0: {
        type: 'MENTION',
        mutability: 'IMMUTABLE',
        data: {
          userId: user.id,
        },
      },
    },
  };
};
